function writeSessionStorage(key, value) {
    if (typeof window !== 'undefined') {
        return window.sessionStorage.setItem(key, JSON.stringify(value));
    }
    return null;
}

function readSessionStorage(key) {
    if (typeof window !== 'undefined') {
        return JSON.parse(window.sessionStorage.getItem(key));
    }
    return null;
}

export {writeSessionStorage, readSessionStorage};
